import { Modal } from "@talladega/components";
import { CheckCircleIcon } from "@talladega/icons";
import { useTranslation } from "next-i18next";

type Props = {
  isOpen: boolean;
  setState: (state: boolean) => void;
  modalDescription?: string;
};

export const FormSubmissionModal = ({
  isOpen,
  setState,
  modalDescription = undefined,
}: Props) => {
  const { t } = useTranslation(["common"]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setState(false);
      }}
      alignment="center"
      customIcon={
        <div className="relative inline-flex h-12 w-12 items-center justify-center rounded-full bg-gray-25 p-2">
          <span className="absolute z-0 h-5 w-5 bg-white text-center" />
          <CheckCircleIcon className="z-10 h-10 w-10 text-green-400" />
        </div>
      }
      title={t("common:form_success_modal_title") ?? ""}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="mb-4 w-7/12 text-center">
          <h5 className="pb-2 text-center text-primary-deep">
            {t("common:form_success_modal_header")}
          </h5>
          <div className="text-left md:text-center">
            <p className="text-primary-deep">
              {modalDescription || t("common:form_success_modal_description")}
            </p>
          </div>
        </div>
      </div>
      <Modal.Buttons
        primaryButtonText={t("common:form_success_modal_button")}
        onPrimaryClick={() => {
          setState(false);
        }}
      />
    </Modal>
  );
};

export default {};
